"use client";

import { Heading } from "@/components/core/heading";

// @ts-ignore
import ConvertKitForm from 'convertkit-react';

interface Props {
    config: { email_form_id: string, email_cta:string }
}

export default function LinkSubscribe({ config, ...props }: Props) {

    const isDev = process.env.NODE_ENV === 'development';

    const emailConfig = {
        formId: config.email_form_id,
        template: 'clare',
        submitText: 'I volunteer my inbox',
        buttonBackground: "#F7FF07",
        buttonColor: "#3E3E3D",
        hideName: true,
        namePlaceholder: "Name",
        emailPlaceholder: "Email"
    }

    return (
        <div className="subscribe space-y-4">
            {emailConfig &&
                <>
                    <Heading as='h2' size="3xl" color='white' content={config.email_cta} />
                    {!isDev &&
                        <ConvertKitForm {...emailConfig} />
                    }
                </>
            }
        </div>
    )
}